/**
 * InputPassword - Password-specific wrappers around InputSecret
 */

import { cn } from '@heltarchat/ui';
import React, { ChangeEventHandler, memo } from 'react';
import { KeyRound } from 'lucide-react';
import { InputSecret } from '../InputSecret';

interface Props {
  password: React.MutableRefObject<HTMLInputElement | null>;
}

export const InputPassword = memo(function InputPassword(props: Props) {
  return (
    <InputSecret
      id='password'
      placeholder='Enter your password'
      inputClassName='h-11 !border-[1px] border-[var(--heltar-border-input)] focus:border-[var(--heltar-border-input-focus)]'
      inputRef={props.password}
      required
      leftIcon={<KeyRound className='h-4 w-4' />}
    />
  );
});

interface PropsState {
  value: string | number | readonly string[] | undefined;
  onChange: ChangeEventHandler<HTMLInputElement>;
  className?: string;
}

export const InputPasswordByState = memo(function InputPasswordByState({
  value,
  onChange,
  className,
}: PropsState) {
  return (
    <InputSecret
      id='password'
      placeholder='Enter your password'
      inputClassName={cn(
        'h-9 !border-[1px] border-[var(--heltar-border-input)] focus:border-[var(--heltar-border-input-focus)]',
        className,
      )}
      value={value}
      onChange={onChange}
      required
      leftIcon={<KeyRound className='h-4 w-4' />}
    />
  );
});
